import React from 'react';

import { Icon, Link as ChakraLink } from '@chakra-ui/react';
import { FaChevronRight } from '@react-icons/all-files/fa/FaChevronRight';
import { Link as GatsbyLink } from 'gatsby';

export const Link = React.forwardRef(({ to, children, showAngleRight = true, ...rest }, ref) => {
	return (
		<ChakraLink
			as={GatsbyLink}
			to={to}
			display="inline-block"
			color="primary.500"
			fontWeight="semibold"
			_hover={{ textDecoration: 'none' }}
			role="group"
			ref={ref}
			{...rest}
		>
			{children}
			{showAngleRight && (
				<Icon
					boxSize="3"
					as={FaChevronRight}
					ml={1}
					transition="transform .3s"
					_groupHover={{ transform: 'scale(1.15) translateX(8px)' }}
				/>
			)}
		</ChakraLink>
	);
});
